













import { Component, Prop, Vue } from "vue-property-decorator";
// components
import FileManager from "@/components/files/FileManager.vue";
// service methods
import { getFolder } from "@/services/files/fileService";
// types
import { MediaType, VscFile } from "@/services/files/types";
import { FileManagerMode } from "@/components/files/types";

@Component({
    components: {
        FileManager
    }
})
export default class FileSelectModal extends Vue {
    @Prop() type!: MediaType;
    @Prop({ default: "modal-fileSelect" }) id!: string;
    selectedFile = {} as VscFile;
    folderId = "";
    fileId = "";

    get mode() {
        if (this.type === MediaType.ImageAndDocument) return MediaType.ImageAndDocument;
        return (this.type === MediaType.Image) ? FileManagerMode.Image : FileManagerMode.Video;
    }

    // methods
    open(fileId: string = "") {
        this.folderId = "";
        this.fileId = "";
        if (fileId !== "") {
            getFolder(fileId).then(response => {
                if (response !== "") {
                    this.fileId = fileId;
                    this.folderId = response;
                }
                this.$bvModal.show(this.id);
            });
        } else {
            this.$bvModal.show(this.id);
        }
    }

    fileSelected(file: VscFile) {
        this.selectedFile = file;
    }

    select() {
        if (Object.keys(this.selectedFile).length > 0) {
            this.$emit("select", { fileId: this.selectedFile.id, name: this.selectedFile.name });
        }
    }

    close() {
        this.folderId = "";
        this.fileId = "";
        this.$bvModal.hide(this.id);
    }
}
